export const isAuthorizedOrLoading = (state) =>
    state.getIn(['authorization', 'isAuthorized']) || state.getIn(['authorization', 'isLoading'])
